import React from 'react'
import { Box, Typography } from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded'
import { useFirebase } from 'src/firebase/useFirebase'
import { Program } from 'src/legacy/models/firebase'
import { useTodaysRecommendation } from '../useParticipantName'
import { humanizeRole } from '../format'
import { onDark } from '../theme'
import Section from './Section'
import EmptyNote from './EmptyNote'

const TodaysRecommendation = ({ uid, programID }: { uid: string; programID?: string | null }) => {
  const { loading, tasks } = useTodaysRecommendation(uid)
  const program = useFirebase<Pick<Program, 'lessons'>>(programID ? `programs/${programID}` : null)

  if (loading) {
    return null
  }

  const doneCount = tasks.filter((task) => task.completedAt).length

  return (
    <Section
      title="Today's recommendation"
      action={
        tasks.length > 0 && (
          <Typography variant="subtitle2" sx={{ color: onDark.secondary }}>
            {doneCount} of {tasks.length} done
          </Typography>
        )
      }
    >
      {tasks.length === 0 ? (
        <EmptyNote>Nothing recommended for today.</EmptyNote>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {tasks.map((task) => {
            const Icon = task.completedAt ? CheckCircleRoundedIcon : RadioButtonUncheckedRoundedIcon

            return (
              <Box key={task.taskID} sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                <Icon
                  sx={{ mt: '2px', fontSize: 18, color: task.completedAt ? onDark.accentGreen : onDark.secondary }}
                />
                <Typography
                  variant="subtitle1"
                  sx={{ color: task.isDisabled ? onDark.secondary : onDark.primary, minWidth: 0 }}
                >
                  {program.data?.lessons?.[task.lessonID]?.title || humanizeRole(task.title || task.lessonID)}
                </Typography>
              </Box>
            )
          })}
        </Box>
      )}
    </Section>
  )
}

export default TodaysRecommendation
